import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'

// definitionsFromContext returns identifiers in the form of folder-name--file-name, which is unnecessarily verbose
const simplifiedDefinitionsFromContext = (context: object): array => {
  return definitionsFromContext(context).map(d => simplifyIdentifier(d))
}

const simplifyIdentifier = (definition: object): object => {
  definition.identifier = definition.identifier.split('--').slice(-1)[0]
  return definition
}

const application = Application.start()
globalThis._APPLICATION_ = application
const context = require.context('../../components', true, /_controller\.ts$/)
application.load(simplifiedDefinitionsFromContext(context))
